import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { get } from 'ctm-util-functions';
import { Text } from '../../text/text';
import style from './product_details_list.css';
import { ModalContainer } from '../../modal/modal_container';
import { TextTemplate } from '../../text_template/text_template';

const ProductDetailsList = ({ defaultValue, stateKey, stateProps, variant, modalProps = {}, componentDisplay }) => {
    const innerHTML = get(stateProps, stateKey);
    const { product } = stateProps;
    const classKey = `variant_${variant}`;
    const display = componentDisplay ? `display_${componentDisplay}` : 'display_block';
    const classes = classNames(style.root, style[classKey], style[display]);
    return innerHTML ? (
        <div className={classes}>
            <Text innerHTML={innerHTML.substring(innerHTML.indexOf('<ul>'), innerHTML.length)} />
            &nbsp;
            { product.getIn(['productMeta', 'specialConditionsReadMore'])
            && (
                <ModalContainer {...modalProps}>
                    <TextTemplate innerHTML={product.getIn(['productMeta', 'specialConditionsReadMore'])} />
                </ModalContainer>
            ) }
        </div>
    ) : (<p>{defaultValue}</p>);
};

ProductDetailsList.propTypes = {
    defaultValue: PropTypes.string,
    stateKey: PropTypes.string,
    stateProps: PropTypes.object,
    variant: PropTypes.string,
    componentDisplay: PropTypes.string,
    modalProps: PropTypes.shape({
        openComponent: PropTypes.array,
        stateProps: PropTypes.object
    })
};

export { ProductDetailsList };
